import React, { useEffect, useState } from 'react';
import Input from '@material-ui/core/Input';
import classnames from 'classnames';
import styles from './index.module.scss';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  input: {
    color: theme.palette.text.primary,
    height: '100%',
  },
  formControl: {
    marginBottom: '0.5rem',
  },
  errorVisible: {
    opacity: 1,
  },
  errorHidden: {
    opacity: 0,
  },
  timepickerInputColor: {
    color: theme.palette.text.primary,
  },
}));

const DateTimeInput = ({
  required,
  index,
  date,
  handleChange,
  separator,
  inputProps,
  className = '',
  disabled = false,
  ...props
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(date);

  useEffect(() => {
    setValue(date || '');
  }, [date]);

  const onFocus = e => e.target.select();

  const handleKeyPress = e => {
    const { maxLength, max, value } = e.target;
    const { key } = e;

    const currentValue = isNaN(Number(key)) ? `${value}` : `${value}${key}`;
    const isSelected = window.getSelection().type === 'Range';

    if (isSelected) {
      const element = window.getSelection();
      const category = element.anchorNode.getAttribute('data-category');

      if (category === e.target.getAttribute('category')) {
        return true;
      }
    }

    if (currentValue.length === Number(maxLength)) {
      if (max && Number(currentValue) > Number(max)) {
        e.preventDefault();
      }
    }

    if (currentValue.length > Number(maxLength)) {
      e.preventDefault();
    }

    return true;
  };

  const handleBlurChange = e => {
    const { value } = e.target;

    if (!isNaN(value) && value.length < 2 && Number(value) < 10) {
      if (!value) {
        return;
      }
      setValue(`0${value}`);
      e.target.value = `0${value}`;
      handleChange(e);
    }
  };

  return (
    <FormControl required={required}>
      <Input
        className={classnames(
          classes.input,
          styles.block,
          styles.timepickerInput,
          classes.timepickerInputColor,
        )}
        type="number"
        disableUnderline
        data-index={index}
        data-category={inputProps.category}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        inputProps={{
          className,
          min: 0,
          maxLength: 2,
          onFocus,
          onKeyDown: handleKeyPress,
          onBlur: handleBlurChange,
          ...inputProps,
        }}
        {...(separator && { endAdornment: separator })}
        {...props}
      />
    </FormControl>
  );
};

DateTimeInput.propTypes = {
  index: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.string,
  separator: PropTypes.string,
  date: PropTypes.string,
  inputProps: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default DateTimeInput;
